import React from 'react';
import PropTypes from 'prop-types';
import { Dimmer, Loader } from 'semantic-ui-react'

class Loaded extends React.Component {
  render() {
    const { loading, style } = this.props

    return (
      <div>
        <Dimmer active={loading} inverted style={{backgroundColor: '#eeeeeecc', zIndex: '10'}}>
          <Loader active size='big' style={{...style, color: 'black'}}>Loading</Loader>
        </Dimmer>
        { !loading && this.props.children }
      </div>
    );
  }

}

Loaded.propTypes = {
  loading: PropTypes.bool.isRequired,
}

export default Loaded;
